import React, { useRef, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Line } from "react-chartjs-2";
import ClickAction from "../ClickAction/ClickAction";
import Calendar from "react-calendar";
import StatsInfoElement from "../StatsInfoElement/StatsInfoElement";

import style from "./StatsGraph.module.css";
import { isObjectEmpty } from "../../assets/Js/isObjectEmpty";

import { useDateFormater } from "../../Hooks/useDateFormater";
import { roleEnum } from "../../assets/Js/roleEnum";

import { colors } from "./StatsGraphDefaultInformation";
import { useUTCLocalConvertor } from "../../Hooks/UTCLocalConvertor";
import { dateFormatEnum } from "../../assets/Js/dateFormatEnum";

const options = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false,
      position: "top",
    },
    title: {
      display: false,
      text: "Chart.js Line Chart",
    },
  },
  scales: {
    y: {
      beginAtZero: true,
      ticks: {
        stepSize: 1,
      },
    },
  },
};

export default function StatsGraph({
  chartData,
  handleDateSelection,
  startDate,
  endDate,
  desiredRole,
  loggedInUserRole,
  isLoading,
}) {
  const [GraphData, setGraphData] = useState({});
  const [showCalendar, setShowCalendar] = useState(false);
  const [userColors, setUserColors] = useState([]);

  const dateFromater = useDateFormater();
  const UTCLocal = useUTCLocalConvertor();

  const calendarRef = useRef();

  useEffect(() => {
    document.addEventListener("mousedown", clickOutsideCalander);
    return () => {
      document.removeEventListener("mousedown", clickOutsideCalander);
    };
  }, []);

  useEffect(() => {
    setUserColors(findColorsBasedOnUsers());
  }, [desiredRole]);

  useEffect(() => {
    chartData &&
      !isObjectEmpty(chartData) &&
      reformatData(Object.entries(chartData));
  }, [chartData]);

  const findColorsBasedOnUsers = () => {
    let _colors =
      desiredRole === roleEnum.owner ? colors.gymColors : colors.athleteColors;

    return _colors;
  };

  const clickHandler = (e) => {
    setShowCalendar((prevState) => !prevState);
  };

  const localHandleDateSelection = (selectedDate) => {
    setShowCalendar(false);
    handleDateSelection(selectedDate);
  };

  const extractInfoOfThisData = (value) => {
    let _value = value.toLowerCase().split(" ").join("");

    let matchedValue = userColors.find(
      (eachVal) => eachVal.name.toLowerCase().split(" ").join("") === _value
    );

    return matchedValue ? { ...matchedValue } : {};
  };

  const reformatDates = (arr) => arr.map((eachVal) => dateFromater(UTCLocal({type: dateFormatEnum.local, date:eachVal})));

  const reformatData = (localDatasets) => {
    let _graphData = {
      labels: reformatDates(localDatasets[0][1]),
      datasets: [...localDatasets.slice(1)].map((eachVal, index) => {
        let { label, color } = extractInfoOfThisData(eachVal[0]);

        if (index <= userColors.length) {
          return {
            label: label,
            data: eachVal[1],
            backgroundColor: color,
            borderColor: color,
            fill: false,
            pointBackgroundColor: color,
            pointBorderColor: color,
            pointHoverBackgroundColor: color,
            pointHoverBorderColor: color,
          };
        }
      }),
    };

    setGraphData(_graphData);
  };

  const clickOutsideCalander = (event) => {
    if (
      calendarRef &&
      calendarRef.current &&
      !calendarRef.current.contains(event.target)
    ) {
      setShowCalendar(false);
    }
  };

  return (
    <>
      <div class="row">
        <div class="col-12 grid-margin stretch-card mb-4">
          <div class="card">
            <div class="card-body">
              <div class="chartjs-size-monitor">
                <div class="chartjs-size-monitor-expand">
                  <div class=""></div>
                </div>
                <div class="chartjs-size-monitor-shrink">
                  <div class=""></div>
                </div>
              </div>

              <div className="row m-0">
                <div className="col-lg-6">
                  <p class="card-title">Engagements on Workouts</p>
                  <p class="mb-4">
                    Graphical presentation of logged workouts, likes and
                    comments
                  </p>
                </div>
                <div className="position-relative col-lg-6">
                  <ClickAction
                    clickHandler={clickHandler}
                    renderProps={({ clickHandler }) => (
                      <StatsInfoElement
                        containerClasses="d-flex flex-grow-1 align-items-center p-3 item justify-content-end"
                        iconClasses="mdi mdi-calendar-heart text-primary"
                        textClasses={`pointerCursor noHighLight ${style.dateText}`}
                        title="Date"
                        subTitle={`${startDate} - ${endDate}`}
                        clickHandler={clickHandler}
                      />
                    )}
                  />

                  {showCalendar && (
                    <div ref={calendarRef}>
                      <Calendar
                        onChange={localHandleDateSelection}
                        className={`dateDropDown ${style.calendarBox} shadow`}
                        value={new Date()}
                      />
                    </div>
                  )}
                </div>
              </div>

              <>
                <div
                  id="cash-deposits-chart-legend"
                  class="d-flex justify-content-center pt-3"
                >
                  <ul class="dashboard-chart-legend">
                    {GraphData?.datasets?.map((eachVal, index) => (
                      <li key={index}>
                        <span
                          style={{ backgroundColor: eachVal.backgroundColor }}
                        ></span>
                        {eachVal.label}
                      </li>
                    ))}
                  </ul>
                </div>
                {!isObjectEmpty(GraphData) && (
                  <div className={`mt-5 ${style.graphHeight}`}>
                    <Line data={GraphData} options={options} height="inherit" />
                  </div>
                )}
              </>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

StatsGraph.propTypes = {
  chartData: PropTypes.object,
  handleDateSelection: PropTypes.func,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  desiredRole: PropTypes.string,
  loggedInUserRole: PropTypes.string,
  isLoading: PropTypes.bool,
};
